import { render, staticRenderFns } from "./CouponNum.vue?vue&type=template&id=36d00f3a&scoped=true"
import script from "./CouponNum.vue?vue&type=script&lang=js"
export * from "./CouponNum.vue?vue&type=script&lang=js"
import style0 from "./CouponNum.vue?vue&type=style&index=0&id=36d00f3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d00f3a",
  null
  
)

export default component.exports